import styles from './Loading.module.scss';

export function Loading() {
  return (
    <div className={styles.containerLoading}>
      <div className={styles.spinner} />
      <p className={styles.text}>Cargando menú...</p>
    </div>
  );
}
